import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85f10b14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-jc-between" }
const _hoisted_2 = { class: "tags p-d-flex p-flex-row p-ai-center p-jc-center" }
const _hoisted_3 = { class: "p-d-flex p-jc-end p-ai-center" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_input_wrapper = _resolveComponent("input-wrapper")!
  const _component_community_tag = _resolveComponent("community-tag")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_Button = _resolveComponent("Button")!
  const _component_rich_text_editor = _resolveComponent("rich-text-editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isTextEditorOpen)
          ? (_openBlock(), _createBlock(_component_input_wrapper, {
              key: 0,
              label: _ctx.copies.selectPlaceholder
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_input, {
                  onHandleSelector: _ctx.handleSelector,
                  name: 'handleSelector',
                  options: _ctx.topicOptions,
                  valueSuggested: _ctx.topicOptions[0].value
                }, null, 8, ["onHandleSelector", "options", "valueSuggested"])
              ]),
              _: 1
            }, 8, ["label"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.communityTags, (tag) => {
              return (_openBlock(), _createBlock(_component_community_tag, {
                class: "p-mr-2",
                key: tag.key,
                value: tag.tag,
                defaultState: _ctx.selectedFilters.some((filter) => filter.key === tag.key),
                onClick: () => _ctx.handleFilters(tag)
              }, null, 8, ["value", "defaultState", "onClick"]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_input_text, {
            modelValue: _ctx.searchByTitle,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchByTitle) = $event)),
            type: "text",
            placeholder: _ctx.copies.search.placeholder,
            style: {"background-color":"var(--black) !important","border":"none !important"}
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_Button, {
          onClick: _ctx.toggleOpenTextEditor,
          label: _ctx.textEditorButton.label,
          icon: _ctx.textEditorButton.icon,
          class: "secondary"
        }, null, 8, ["onClick", "label", "icon"])
      ])
    ]),
    (_ctx.isTextEditorOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_rich_text_editor, {
            buttons: { draft: true, publish: true },
            onOnChange: _ctx.handleTextEditor,
            placeholder: _ctx.copies.inputPost.placeholder
          }, null, 8, ["onOnChange", "placeholder"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}